// MassageDerniereMinute: English text for the Top bar and Footer, which come from Sharetribe
// Console (Build > Content > Top bar / Footer) as a single set shared by both deployments -
// unlike the landing page, Console doesn't support a second, named copy of these. Applied on
// the samedaymassage.ca deployment (REACT_APP_FORCE_LOCALE=en) in src/util/configHelpers.js.
export default {
  // Keyed by the link's href (more stable than its French text).
  topbarCustomLinks: {
    '/signup': 'Join the platform',
  },
  footer: {
    slogan: 'Same-day massage, whenever you need it. 🌲',
    copyright: '© 2026 SameDayMassage.ca. All rights reserved.',
    // Keyed by the footer block's Console blockId.
    blocks: {
      'terms-and-privacy':
        "- [Terms of Service](/terms-of-service)\n- [Privacy Notice](/privacy-policy)",
    },
    // Keyed by social platform name - Same Day Massage's own accounts.
    socialMediaLinks: {
      facebook: 'https://www.facebook.com/profile.php?id=61591055264328',
      instagram: 'https://www.instagram.com/samedaymassage',
    },
  },
};
